import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Company } from '../models/company';
import { CompanyWorkingHours } from '../models/company-working-hours';


@Injectable()
export class CompanyInfoService {

  constructor() { }

  getCompanyInfo(): Observable<Company> {
    return of();
  }

  getSchedule(): Observable<CompanyWorkingHours[]> {
    return of();
  }
  getTodayWorkingHours(): Observable<CompanyWorkingHours> {
    return of();
  }
}
